import Div from '@ui/layout/Div'
import { useEffect, useState } from 'react'
import { loginFormFields, loginUrl } from '@form/loginFormFields'
import { post, apiTokenId } from '@util/xhrAPI'
import { useDispatch, useSelector } from 'react-redux'
import { updateLoginFormObject, initLogin, updateLoginErrors } from '@store/slice/loginSlice'
import { mainFullUpdate } from '@store/slice/mainSlice'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router'
import useStoreUpdate from '@hook/useStoreUpdate'
import useFormData from '@hook/useFormData'
import Alert from '@ui/elements/Alert'
import Image from '@ui/elements/Image'
import Form from '@ui/elements/Form'

const Login = () => {
  const [t] = useTranslation('form')
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const [isLoading, setLoading] = useState(false)
  const { loginFormObject, errors } = useSelector(state => state.login)
  const { mission, logguedUser } = useSelector(state => state.main)
  const [updateFormObject] = useStoreUpdate(dispatch, updateLoginFormObject, { ...loginFormObject, mission: mission.id })
  const renderFormData = useFormData()

  const renderAlerts = () => {
    if (errors.length) {
      return errors.map(error => <Alert message={t(`alerts.${error}`)} type='is-danger' key={`login-error`} />)
    }
  }

  const loginAction = () => {
    setLoading(true)
    post(loginUrl, renderFormData(loginFormObject), response => {
      const { code, errors, token, user } = response
      if (code === 200) {
        window.localStorage.setItem(apiTokenId, token)
        dispatch(initLogin())
        dispatch(mainFullUpdate({ logguedUser: { ...user } }))
      } else {
        dispatch(updateLoginErrors([...errors]))
      }
      setLoading(false)
    })
  }

  useEffect(() => {
    if (null !== logguedUser && window.localStorage.getItem(apiTokenId)) {
      navigate('/dashboard')
    }
  }, [logguedUser])

  return (
    <Div cssClass='login-page'>
      <Div cssClass='login-zone'>
        <Image src={mission.missionLogo} />
        {renderAlerts()}
        <Form cssClass='login-form'>
          {loginFormFields(loginFormObject, updateFormObject, loginAction, errors, isLoading, t)}
        </Form>
      </Div>
    </Div>

  )
}

export default Login